import { render, staticRenderFns } from "./ModalCallHistory.vue?vue&type=template&id=128e5c82&scoped=true&"
import script from "./ModalCallHistory.vue?vue&type=script&lang=js&"
export * from "./ModalCallHistory.vue?vue&type=script&lang=js&"
import style0 from "./ModalCallHistory.vue?vue&type=style&index=0&id=128e5c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128e5c82",
  null
  
)

component.options.__file = "ModalCallHistory.vue"
export default component.exports